import React from 'react'
import "../healthy_life/HealthyLife.css"
import { Col, Container, Row } from 'react-bootstrap'
const HealthyLife = () => {
  return (
    <>
      <section id="healthy_life">
        <Container>
          <Row>
            <Col lg={12}>
            <div class="healthy_life_main">
              <div class="healthy_life_inner">
                <h1>Fruits For Live Healthy</h1>
                <p>Donec sollicitudin molestie malesuada. Lorem ipsum <br/>
                  dolor sit amet,consectetur adipiscing elit.</p>
                <button class="shop_now">shop now</button>
                
              </div>
            </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default HealthyLife